import { render, staticRenderFns } from "./CustomerRequestFileNew.vue?vue&type=template&id=33eb307e&"
import script from "./CustomerRequestFileNew.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestFileNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCardSection,QForm,QInput,QSelect,QField,QCheckbox,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCardSection,QForm,QInput,QSelect,QField,QCheckbox,QSeparator,QCardActions,QBtn})
